<div class="layout-topbar">
  <div class="topbar-start">
    <app-button (onClick)="toggleMenu()" [text]="true" class="topbar-menubutton" icon="pi pi-bars" severity="contrast"/>
    <a class="topbar-logo" routerLink="/">
      <img alt="Generation Y Logo" height="40" src="/generation-y-dev-logo-optimized.svg"/>
    </a>
  </div>

  <div class="topbar-end">
    <div class="topbar-selects">
      <p-select
        (ngModelChange)="onCompanyChange($event)"
        [ngModel]="selectedCompanyId$ | async"
        [options]="(companies$ | async) ?? []"
        optionLabel="name"
        optionValue="id"
        placeholder="Selecteer bedrijf"
      />
      <p-select
        (ngModelChange)="onWebshopChange($event)"
        [disabled]="(webshopSelectDisabled$ | async) === true"
        [ngModel]="selectedWebshopId$ | async"
        [options]="(webshops$ | async) ?? []"
        optionLabel="name"
        optionValue="id"
        placeholder="Selecteer webshop"
      />
    </div>
    <app-button (onClick)="logout()" class="topbar-button" icon="pi pi-sign-out" label="Logout" severity="contrast" text="true"/>
  </div>
</div>
